import React from 'react';
import Portfolio from '../../components/Portfolio';

function Home() {
  return (
    <div className="relative left-1/2 right-1/2 -ml-[50vw] -mr-[50vw] w-screen px-0">
      <Portfolio />
    </div>
  );
}

export default Home; 